import { render, staticRenderFns } from "./AppMenuLateral.vue?vue&type=template&id=3cc05ade&"
import script from "./AppMenuLateral.vue?vue&type=script&lang=js&"
export * from "./AppMenuLateral.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuLateral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports